import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { DashboardResponseDTO } from "@inosio/payments-sdk";

type DashboardState = {
    dashboardResponse: DashboardResponseDTO
    isFetchingDashboardData: boolean,
    isFetchingDashboardDataSuccess: boolean,
    isFetchingDashboardDataFailed: boolean,
    errorMessage: string,
};
const getInitialState = () => {
    return {
        dashboardResponse: {},
        isFetchingDashboardData: true,
        isFetchingDashboardDataSuccess: false,
        isFetchingDashboardDataFailed: false,
        errorMessage: '',
    } as DashboardState;
};
const pmDashboardSlice = createSlice({
    name: "pmDashboard",
    initialState: getInitialState(),
    reducers: {
        getDashboardData(state, action) {
            state.isFetchingDashboardDataSuccess = false;
            state.isFetchingDashboardData = true
        },
        setDashboardData(state, action) {
            const response = {
                isFetchingDashboardDataSuccess: true,
                isFetchingDashboardData: false,
                isFetchingDashboardDataFailed: false,
                dashboardResponse: action.payload
            }
            return { ...state, ...response };
        },
        getDashBoardDataFailed(state, action) {
            state.isFetchingDashboardDataSuccess = false
            state.isFetchingDashboardData = false
            state.isFetchingDashboardDataFailed = true
            state.errorMessage = action.payload
        }
    }
});
export const {
    getDashboardData,
    setDashboardData,
    getDashBoardDataFailed
} = pmDashboardSlice.actions;

export default pmDashboardSlice.reducer;
export const selectDashboardState = (state: RootState) => state.pmDashboardState.dashboardResponse;
